var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:currentColor;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light-M"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,113.5c-1,0-2-0.4-2.7-1.2l-32-32l-32,32c-0.7,0.7-1.7,1.1-2.7,1.1c-1,0-2-0.4-2.7-1.1 c-0.7-0.7-1.1-1.6-1.1-2.6c0-1,0.4-2,1.1-2.8l32-32l-32-32c-1.5-1.5-1.5-3.9,0-5.4c0.7-0.7,1.7-1.1,2.7-1.1c1,0,2,0.4,2.7,1.1 l32,32l32-32c0.7-0.7,1.7-1.1,2.7-1.1c1,0,2,0.4,2.7,1.1c0.7,0.7,1.1,1.6,1.1,2.7c0,1-0.4,2-1.1,2.8l-32,32l32,32 c1.5,1.5,1.5,3.9,0,5.3C111.7,113.1,110.7,113.5,109.7,113.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHClose);
export default __webpack_public_path__ + "static/media/h_close.a895fdf9937be8bfd30795b4e38772a4.svg";
export { ForwardRef as ReactComponent };